import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { Card, Typography } from '@mui/material';
import React from 'react';

export type PanierCardInfoProps = {
    selectionnables?: boolean;
};

const PanierCardInfo: React.FunctionComponent<PanierCardInfoProps> = function ({
    selectionnables = false,
}) {
    return (
        <Card
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '15px',
            }}
        >
            <Typography
                variant="l2dh6"
                display="flex"
                gap="5px"
            >
                <FaOptionIcon icon={['fasl', 'credit-card']} />
                Paiement 100 % sécurisé
            </Typography>
            <Typography>
                Votre paiement est entièrement sécurisé grâce à notre partenaire de confiance.
                Toutes les transactions sont chiffrées et vos données bancaires sont protégées à
                chaque étape.
            </Typography>
            {selectionnables && (
                <Typography>
                    Vous gardez le contrôle total sur votre règlement : sélectionnez librement les
                    éléments que vous souhaitez payer maintenant, puis validez votre paiement en
                    toute sérénité.
                </Typography>
            )}
            <Typography>
                Nous mettons tout en œuvre pour vous garantir une expérience fluide, rapide et sûre
                — parce que votre confiance est notre priorité.
            </Typography>
        </Card>
    );
};

export default PanierCardInfo;
